import {
    implementOperation,
    IOperationActionCreator,
    ItemOperationError,
    IItemOperationErrorProps
} from '../store/actions/implementOperation';
import { Facet } from '../models/Facet';
import { ConflictResolution } from '../facets/ProgressFacets';

/**
 * @public
 */
export interface IUploadItemOptions {
    conflictResolution?: ConflictResolution;
}

/**
 * @public
 */
export const uploadItemsOperation = new Facet<{
    /**
     * This is the key for the new, child item presently assigned by the caller.
     * The data source will map this to the true item key once it knows the identity
     * of the uploaded item.
     */
    sourceEntries: {
        [itemKey: string]: IUploadItemOptions & {
            progressItemKey?: string;
        };
    };
}>('uploadItems');

/**
 * @public
 */
export const uploadItems: IOperationActionCreator<typeof uploadItemsOperation.type> = implementOperation({
    operationTypeFacet: uploadItemsOperation
});

/**
 * @public
 */
export interface IUploadItemOperationErrorProps extends IItemOperationErrorProps {
    // Nothing added.
}

/**
 * @public
 */
export class UploadItemOperationError extends ItemOperationError {
    // Nothing added.
}
